const PREFIX = '/l/1/';
const GUEST_PREFIX = '/g/1/';
export const createDirectLinks = (directLinks) => {
    return new DirectLinksImpl(directLinks);
};
class DirectLinksImpl {
    directLinks;
    constructor(directLinks) {
        this.directLinks = directLinks;
    }
    async generate(baseUrl, path, version) {
        return this.directLinks.generate(baseUrl, path, version);
    }
    async generateGuestLink(baseUrl, path, version, invitationSecretKey) {
        const link = await this.generate(baseUrl, path, version);
        return `${link.replace(PREFIX, GUEST_PREFIX)}#${invitationSecretKey}`;
    }
    async follow(params) {
        const webfsParams = {
            id: params.entryId,
            parentId: params.parentEntryId,
            entryName: params.fileName,
            decryptFileName: 'yes',
        };
        return this.directLinks.follow(webfsParams);
    }
}
